import {Route} from 'react-router-dom';
import RestaurantBase from '../components/template/base/RestaurantBase';
import {AddOnsRoutes} from './AddOnsRoutes';
import InstagramPosts from '../components/pages/instagram/InstagramPosts';
import InstagramInsights from '../components/pages/instagram/InstagramInsights';
import InstagramApiReturn from '../components/pages/instagram/InstagramApiReturn';
import Instagram from '../components/pages/instagram/Instagram';
import InstagramSetting from "../components/pages/instagram/InstagramSetting";
import InstagramContents from "../components/pages/instagram/InstagramContents";
import InstagramContentsDetail from "../components/pages/instagram/InstagramContentsDetail";
import InstagramBotSettings from "../components/pages/instagram/InstagramBotSettings";
import InstagramBotCreate from "../components/pages/instagram/InstagramBotCreate";
import InstagramDmCreate from "../components/pages/instagram/InstagramDmCreate";
import InstagramPackageCreate from "../components/pages/instagram/InstagramPackageCreate";
import InstagramDmReceive from "../components/pages/instagram/InstagramDmReceive";
import InstagramDmContents from '../components/pages/instagram/InstagramDmContents';
import InstagramPackageContents from '../components/pages/instagram/InstagramPackageContents';
import InstagramAuthCallback from "../components/pages/instagram/InstagramAuthCallback";
import { InstagramDmHistory } from '../components/pages/instagram/InstagramDmHistory';

export const InstagramRoutes = (
    <Route path="restaurants/:restaurantId" element={<RestaurantBase />}>
            {/* Instagram関連のルートを追加 */}
            <Route path="instagram/view" element={<Instagram />} />
            <Route path="instagram/settings" element={<InstagramSetting />} />
            <Route path="instagram/posts" element={<InstagramPosts />} />
            <Route path="instagram/insights" element={<InstagramInsights />} />
            <Route path="instagram-api-return" element={<InstagramApiReturn />} /> {/* リダイレクト後の戻り先 */}
            <Route path="instagram/contents" element={<InstagramContents />} />
            <Route path="instagram/details/:contentId" element={<InstagramContentsDetail />} />
            <Route path="instagram/bot/settings" element={<InstagramBotSettings />} />
            <Route path="instagram/bot/create" element={<InstagramBotCreate />} />
            <Route path="instagram/dm/create" element={<InstagramDmCreate />} />
            <Route path="instagram/dm" element={<InstagramDmContents />} />
            <Route path="instagram/dm/:id/edit" element={<InstagramDmCreate />} />
            <Route path="instagram/package/create" element={<InstagramPackageCreate />} />
            <Route path="instagram/package" element={<InstagramPackageContents />} />
            <Route path="instagram/package/:id/edit" element={<InstagramPackageCreate />} />
        <Route
            path="/restaurants/:restaurantId/instagram/dm-history"
            element={<InstagramDmHistory />}
        />

    </Route>
);